export const STEPS = {
  PARTICIPANTS: 1,
  TIMESLOTS: 2,
  FINAL: 3,
};
